export enum AttachmentType {
  Project = 'projects',
  Job = 'jobs',
  JobRequest = 'jobrequests',
  Test = 'tests'
}